import * as React from 'react';
import { IClaimFormJobLossTypeState, IClaimFormJobLossType } from './ClaimFormJobLossTypes';
import { IChildrenProps } from 'types/children';

const initialState: IClaimFormJobLossType = {
    borrowerNameFirst: '',
    borrowerNameMiddle: '',
    borrowerNameLast: '',
    borrowerSuffix: undefined,
    borrowerMailingAddress: '',
    borrowerMailingAddress2: '',
    borrowerMailingCity: '',
    borrowerMailingState: undefined,
    borrowerMailingZip: '',
    borrowerEmail: '',
    borrowerPhone: '',
    borrowerSSN: '',
    borrowerDateOfBirth: '',
    borrowerComments: '',
    iuDateOfJobLoss: '',
    employerName: '',
    employerAddress: '',
    employerCity: '',
    employerState: undefined,
    employerZip: '',
    employerEmail: '',
    employerContactNumber: '',
    iuDateOfJobLossNotification: '',
    iuJobLossReason: '',
    iuAdditionalDetails: '',
    iuDateLastDayWorked: '',
    iuIsLayoffTypicalAtThisTime: '',
    iuKnowledgeOfLayoffWhenHired: '',
    iuOccupationAtTimeOfSeparation: '',
    iuQualifyForStateUnemployment: '',
    iuRejectionStateBenefitsReason: '',
    iuSelfEmployed: '',
    eDeliveryConfirmation: '',
    iuFiledOnBehalfOf: undefined,
    submitterCompanyName: '',
    submitterNameFirst: '',
    submitterNameLast: '',
    submitterEmail: '',
    submitterPhone: ''
};

export const ClaimFormJobLossContext = React.createContext<IClaimFormJobLossTypeState | null>(null);

const ClaimFormJobLossProvider: React.FC<IChildrenProps> = ({ children }) => {
    const [stateClaimFormJobLoss, setStateClaimFormJobLoss] = React.useState<IClaimFormJobLossType>(initialState);
    const saveStateClaimFormJobLoss = (formData: Partial<IClaimFormJobLossType>): void => {
        setStateClaimFormJobLoss((prevState) => ({
            ...prevState,
            ...formData
        }));
    };
    const reinitialiseContextState = (): void => {
        setStateClaimFormJobLoss(initialState);
    };
    const stateObject: IClaimFormJobLossTypeState = {
        contextStateClaimFormJobLoss: stateClaimFormJobLoss,
        updateContextStateClaimFormJobLoss: saveStateClaimFormJobLoss,
        reinitialiseContextStateClaimFormJobLoss: reinitialiseContextState
    };

    return <ClaimFormJobLossContext.Provider value={stateObject}>{children}</ClaimFormJobLossContext.Provider>;
};

export default ClaimFormJobLossProvider;
